import 'select2';
import 'select2/dist/js/i18n/fr';

let { View } = window.App;
let { t } = window.App.I18n;

(
    /**
     * Small Select2 plugin allowing search input placeholder
     */
    function( $ ){

        var Defaults = $.fn.select2.amd.require( 'select2/defaults' );

        $.extend( Defaults.defaults, {
            searchInputPlaceholder: '',
        } );

        var SearchDropdown = $.fn.select2.amd.require( 'select2/dropdown/search' );

        var _renderSearchDropdown = SearchDropdown.prototype.render;

        SearchDropdown.prototype.render = function( decorated ){

            // invoke parent method
            var $rendered = _renderSearchDropdown.apply( this, Array.prototype.slice.apply( arguments ) );

            this.$search.attr( 'placeholder', this.options.get( 'searchInputPlaceholder' ) );

            return $rendered;
        };

    }
)( window.jQuery );

View.addHook( 'init', v => {
    window.App.$document.on( 'input change', 'input', function( e ){
        let $this = $( this );
        let $wrapper = $this.closest( '.field-group' );
        let $error = $wrapper.find( '.field-error' );

        $error.remove();
        $wrapper.removeClass( 'has-error' );
    } );

    $( 'select' ).select2( {
        width                 : '100%',
        searchInputPlaceholder: t( 'search' ),
        language              : window.lang || 'fr',
    } );
} );



// WEBPACK FOOTER //
// ./resources/assets/js/modules/form.js